import type { App } from "vue";
import {
  BatchDataSourceImpl,
  batchDataSourceKey,
} from "./data/datasources/batch_datasource";
import {
  CategoryDataSourceImpl,
  categoryDataSourceKey,
} from "./data/datasources/category_datasource";
import {
  DeviceDataSourceImpl,
  deviceDataSourceKey,
} from "./data/datasources/device_datasource";
import {
  ProductDataSourceImpl,
  productDataSourceKey,
} from "./data/datasources/product_datasource";

import {
  VendorDataSourceImpl,
  vendorDataSourceKey,
} from "./data/datasources/vendor_datasource";

export function initProductModule(app: App) {
  app.provide(categoryDataSourceKey, new CategoryDataSourceImpl());
  app.provide(vendorDataSourceKey, new VendorDataSourceImpl());
  app.provide(productDataSourceKey, new ProductDataSourceImpl());
  app.provide(batchDataSourceKey, new BatchDataSourceImpl());
  app.provide(deviceDataSourceKey, new DeviceDataSourceImpl());
}
